// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file featureflag/v1/ext.proto (package featureflag.v1, syntax proto3)
/* eslint-disable */

import type { GenExtension, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { extDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { EnumValueOptions } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_descriptor } from "@bufbuild/protobuf/wkt";
import type { Date } from "../../google/type/date_pb";
import { file_google_type_date } from "../../google/type/date_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file featureflag/v1/ext.proto.
 */
export const file_featureflag_v1_ext: GenFile = /*@__PURE__*/
  fileDesc("ChhmZWF0dXJlZmxhZy92MS9leHQucHJvdG8SDmZlYXR1cmVmbGFnLnYxInEKD0VudW1GaWVsZE9wdGlvbhIlCgpleHBpcmVkX2F0GAEgASgLMhEuZ29vZ2xlLnR5cGUuRGF0ZRIPCgdnb19uYW1lGAIgASgJSgQIAxAEUgZjb25maWdSGGR1YWxfaW1fcmV0cmlldmFsX2NvbmZpZyJtChtEdWFsSU1SZXRyaWV2YWxDb25maWdPcHRpb24SJQodZGVmYXVsdF9wcmltYXJ5X21vZGVsX3ZlcnNpb24YASABKAkSJwofZGVmYXVsdF9zZWNvbmRhcnlfbW9kZWxfdmVyc2lvbhgCIAEoCTplCgtmZWF0dXJlZmxhZxIhLmdvb2dsZS5wcm90b2J1Zi5FbnVtVmFsdWVPcHRpb25zGOgHIAEoCzIfLmZlYXR1cmVmbGFnLnYxLkVudW1GaWVsZE9wdGlvblILZmVhdHVyZWZsYWdCxwEKEmNvbS5mZWF0dXJlZmxhZy52MUIIRXh0UHJvdG9QAVpOZ2l0aHViLmNvbS9lbmVjaGFpbi9lcG9zaXRpb24tYXBwL2JhY2tlbmQvZ2VuL3Byb3RvL2ZlYXR1cmVmbGFnL3YxO2ZlYXR1cmVmbGFnogIDRlhYqgIORmVhdHVyZWZsYWcuVjHKAg5GZWF0dXJlZmxhZ1xWMeICGkZlYXR1cmVmbGFnXFYxXEdQQk1ldGFkYXRh6gIPRmVhdHVyZWZsYWc6OlYxYgZwcm90bzM", [file_google_protobuf_descriptor, file_google_type_date]);

/**
 * @generated from message featureflag.v1.EnumFieldOption
 */
export type EnumFieldOption = Message<"featureflag.v1.EnumFieldOption"> & {
  /**
   * feature flag削除予定の日付
   *
   * @generated from field: google.type.Date expired_at = 1;
   */
  expiredAt?: Date;

  /**
   * Goの変数名に使われる名前
   *
   * @generated from field: string go_name = 2;
   */
  goName: string;
};

/**
 * Describes the message featureflag.v1.EnumFieldOption.
 * Use `create(EnumFieldOptionSchema)` to create a new message.
 */
export const EnumFieldOptionSchema: GenMessage<EnumFieldOption> = /*@__PURE__*/
  messageDesc(file_featureflag_v1_ext, 0);

/**
 * DualIMRetrieval用の設定オプション
 *
 * @generated from message featureflag.v1.DualIMRetrievalConfigOption
 */
export type DualIMRetrievalConfigOption = Message<"featureflag.v1.DualIMRetrievalConfigOption"> & {
  /**
   * @generated from field: string default_primary_model_version = 1;
   */
  defaultPrimaryModelVersion: string;

  /**
   * @generated from field: string default_secondary_model_version = 2;
   */
  defaultSecondaryModelVersion: string;
};

/**
 * Describes the message featureflag.v1.DualIMRetrievalConfigOption.
 * Use `create(DualIMRetrievalConfigOptionSchema)` to create a new message.
 */
export const DualIMRetrievalConfigOptionSchema: GenMessage<DualIMRetrievalConfigOption> = /*@__PURE__*/
  messageDesc(file_featureflag_v1_ext, 1);

/**
 * @generated from extension: featureflag.v1.EnumFieldOption featureflag = 1000;
 */
export const featureflag: GenExtension<EnumValueOptions, EnumFieldOption> = /*@__PURE__*/
  extDesc(file_featureflag_v1_ext, 0);

